import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const Menu = (props) => {
  const { children, className } = props;
  return <ul className={classNames(className)}>{children}</ul>;
};

Menu.propTypes = {
  className: PropTypes.string,
};
